"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectCard = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Card_1 = __importDefault(require("@material-ui/core/Card"));
var CardContent_1 = __importDefault(require("@material-ui/core/CardContent"));
var atoms_1 = require("../../atoms");
var icons_1 = require("../../icons");
var styles_1 = __importDefault(require("./styles"));
var ProjectCard = function (_a) {
    var id = _a.id, name = _a.name, status = _a.status, _b = _a.isSelected, isSelected = _b === void 0 ? false : _b, testId = _a.testId, _c = _a.onClick, onClick = _c === void 0 ? function () { } : _c;
    var classes = (0, styles_1.default)();
    var clickHandler = function () {
        onClick(id);
    };
    return ((0, jsx_runtime_1.jsx)(Card_1.default, __assign({ className: classes.card, "data-testid": testId, onClick: clickHandler }, { children: (0, jsx_runtime_1.jsxs)(CardContent_1.default, __assign({ className: classes.cardContent }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: classes.icon }, { children: (0, jsx_runtime_1.jsx)(atoms_1.Icon, __assign({ color: "#FDD85D", isSelected: isSelected, simple: true }, { children: (0, jsx_runtime_1.jsx)(icons_1.Favorite, {}) })) })), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(atoms_1.Text, __assign({ weight: "bold", size: "medium" }, { children: id })), ' ', (0, jsx_runtime_1.jsx)(atoms_1.StatusIndicator, { label: status })] }), (0, jsx_runtime_1.jsx)(atoms_1.Text, __assign({ component: "p" }, { children: name }))] })] })) })));
};
exports.ProjectCard = ProjectCard;
